import { render } from "./Customize.vue?vue&type=template&id=7dc3a651&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=ts"
export * from "./Customize.vue?vue&type=script&lang=ts"

import "./Customize.vue?vue&type=style&index=0&id=7dc3a651&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7dc3a651"

export default script